/**
 * Created by fgaule on 11/11/16.
 */
angular.module('CarsSaraBo').controller('LanguageController', ['$translate', '$scope', '$rootScope', '$locale', '$cookieStore', '$translate2',
    function ($translate, $scope, $rootScope, $locale, $cookieStore, $translate2) {
        // This is a hack to i18n bootstrap date picker (calendar)
        var locales = {
            es: {
                "DATETIME_FORMATS": {
                    "AMPMS": [
                        "AM",
                        "PM"
                    ],
                    "DAY": [
                        "domingo",
                        "lunes",
                        "martes",
                        "miércoles",
                        "jueves",
                        "viernes",
                        "sábado"
                    ],
                    "MONTH": [
                        "enero",
                        "febrero",
                        "marzo",
                        "abril",
                        "mayo",
                        "junio",
                        "julio",
                        "agosto",
                        "septiembre",
                        "octubre",
                        "noviembre",
                        "diciembre"
                    ],
                    "SHORTDAY": [
                        "dom.",
                        "lun.",
                        "mar.",
                        "mie.",
                        "jue.",
                        "vie.",
                        "sab."
                    ],
                    "SHORTMONTH": [
                        "Ene",
                        "Feb",
                        "Mar",
                        "Abr",
                        "May",
                        "Jun",
                        "Jul",
                        "Ago",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dic"
                    ],
                    "fullDate": "EEEE d MMMM y",
                    "longDate": "d MMMM y",
                    "medium": "d MMM y HH:mm:ss",
                    "mediumDate": "d MMM y",
                    "mediumTime": "HH:mm:ss",
                    "short": "dd/MM/yy HH:mm",
                    "shortDate": "dd/MM/yy",
                    "shortTime": "HH:mm"
                },
                "NUMBER_FORMATS": {
                    "CURRENCY_SYM": "\u20ac",
                    "DECIMAL_SEP": ",",
                    "GROUP_SEP": "\u00a0",
                    "PATTERNS": [
                        {
                            "gSize": 3,
                            "lgSize": 3,
                            "macFrac": 0,
                            "maxFrac": 3,
                            "minFrac": 0,
                            "minInt": 1,
                            "negPre": "-",
                            "negSuf": "",
                            "posPre": "",
                            "posSuf": ""
                        },
                        {
                            "gSize": 3,
                            "lgSize": 3,
                            "macFrac": 0,
                            "maxFrac": 2,
                            "minFrac": 2,
                            "minInt": 1,
                            "negPre": "(",
                            "negSuf": "\u00a0\u00a4)",
                            "posPre": "",
                            "posSuf": "\u00a0\u00a4"
                        }
                    ]
                },
                "id": "es-ar",
                "pluralCat": function (n) {
                    if (n >= 0 && n <= 2 && n != 2) {
                        return PLURAL_CATEGORY.ONE;
                    }
                    return PLURAL_CATEGORY.OTHER;
                }
            },
            pt: {
                "DATETIME_FORMATS": {
                    "AMPMS": [
                        "AM",
                        "PM"
                    ],
                    "DAY": [
                        "dom",
                        "seg",
                        "ter",
                        "qua",
                        "qui",
                        "sex",
                        "sab"
                    ],
                    "MONTH": [
                        "Janeiro",
                        "Fevereiro",
                        "Março",
                        "Abril",
                        "Maio",
                        "Junho",
                        "Julho",
                        "Agosto",
                        "Setembro",
                        "Outubro",
                        "Novembro",
                        "Dezembro"
                    ],
                    "SHORTDAY": [
                        "dom.",
                        "seg.",
                        "ter.",
                        "qua.",
                        "qui.",
                        "sex.",
                        "sab."
                    ],
                    "SHORTMONTH": [
                        "Jan",
                        "Fev",
                        "Mar",
                        "Abr",
                        "Mai",
                        "Jun",
                        "Jul",
                        "Ago",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dez"
                    ],
                    "fullDate": "EEEE d MMMM y",
                    "longDate": "d MMMM y",
                    "medium": "d MMM y HH:mm:ss",
                    "mediumDate": "d MMM y",
                    "mediumTime": "HH:mm:ss",
                    "short": "dd/MM/yy HH:mm",
                    "shortDate": "dd/MM/yy",
                    "shortTime": "HH:mm"
                },
                "NUMBER_FORMATS": {
                    "CURRENCY_SYM": "\u20ac",
                    "DECIMAL_SEP": ",",
                    "GROUP_SEP": "\u00a0",
                    "PATTERNS": [
                        {
                            "gSize": 3,
                            "lgSize": 3,
                            "macFrac": 0,
                            "maxFrac": 3,
                            "minFrac": 0,
                            "minInt": 1,
                            "negPre": "-",
                            "negSuf": "",
                            "posPre": "",
                            "posSuf": ""
                        },
                        {
                            "gSize": 3,
                            "lgSize": 3,
                            "macFrac": 0,
                            "maxFrac": 2,
                            "minFrac": 2,
                            "minInt": 1,
                            "negPre": "(",
                            "negSuf": "\u00a0\u00a4)",
                            "posPre": "",
                            "posSuf": "\u00a0\u00a4"
                        }
                    ]
                },
                "id": "pt-br",
                "pluralCat": function (n) {
                    if (n >= 0 && n <= 2 && n != 2) {
                        return PLURAL_CATEGORY.ONE;
                    }
                    return PLURAL_CATEGORY.OTHER;
                }
            },
            en: {
                "DATETIME_FORMATS": {
                    "AMPMS": [
                        "AM",
                        "PM"
                    ],
                    "DAY": [
                        "Sunday",
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday"
                    ],
                    "MONTH": [
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December"
                    ],
                    "SHORTDAY": [
                        "Sun",
                        "Mon",
                        "Tue",
                        "Wed",
                        "Thu",
                        "Fri",
                        "Sat"
                    ],
                    "SHORTMONTH": [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                    ],
                    "fullDate": "EEEE, MMMM d, y",
                    "longDate": "MMMM d, y",
                    "medium": "MMM d, y h:mm:ss a",
                    "mediumDate": "MMM d, y",
                    "mediumTime": "h:mm:ss a",
                    "short": "M/d/yy h:mm a",
                    "shortDate": "M/d/yy",
                    "shortTime": "h:mm a"
                },
                "NUMBER_FORMATS": {
                    "CURRENCY_SYM": "$",
                    "DECIMAL_SEP": ".",
                    "GROUP_SEP": ",",
                    "PATTERNS": [
                        {
                            "gSize": 3,
                            "lgSize": 3,
                            "macFrac": 0,
                            "maxFrac": 3,
                            "minFrac": 0,
                            "minInt": 1,
                            "negPre": "-",
                            "negSuf": "",
                            "posPre": "",
                            "posSuf": ""
                        },
                        {
                            "gSize": 3,
                            "lgSize": 3,
                            "macFrac": 0,
                            "maxFrac": 2,
                            "minFrac": 2,
                            "minInt": 1,
                            "negPre": "(\u00a4",
                            "negSuf": ")",
                            "posPre": "\u00a4",
                            "posSuf": ""
                        }
                    ]
                },
                "id": "en-us",
                "pluralCat": function (n) {
                    if (n == 1) {
                        return PLURAL_CATEGORY.ONE;
                    }
                    return PLURAL_CATEGORY.OTHER;
                }
            }
        };

        $scope.languages = [{"name": "pt", "url": "assets/Brazil-Flag.png", "value": "pt"},
            {"name": "es", "url": "assets/Spain-Flag.png", "value": "es"},
            {"name": "en", "url": "assets/United-States-Flag.png", "value": "en"}];
        $scope.selectedLang = 'es';

        $rootScope.updateLanguage = function(lang) {
            $cookieStore.put('sara_language', lang);
            $rootScope.lang = lang;
            $translate.use(lang.value);
            $translate2.use(lang.value);
            window.SUPPLIERS_LANG = lang.value;
            angular.copy(locales[lang.name], $locale);
        };

        if (!$rootScope.lang) {
            var selectedLanguageCookies = $cookieStore.get('sara_language');
            if (selectedLanguageCookies != null && selectedLanguageCookies != undefined) {
                $rootScope.updateLanguage(selectedLanguageCookies);
            } else {
                $rootScope.updateLanguage($scope.languages[1]);
            }
        }

        $scope.changeSelectedValue = function (lang) {
            $rootScope.updateLanguage(lang);
        };

        $scope.showSelector = function () {
            $('.language-selector').show();
        }

        $scope.hideSelector = function () {
            $('.language-selector').hide();
        }

    }]
);


//////////////////
// WEBPACK FOOTER
// ./public/app/controllers/language_controller.js
// module id = 904
// module chunks = 3